export default {
  welcome: 'Welcome to Rapoo A-Hub',
  changeLang: 'Change Language',
  toggleTheme: 'Toggle Theme',
  device: 'Device Management',
  about: 'About Us',
  add: 'Add',
  backButton: 'Back',
  cancel: 'Cancel',
  Deselect: 'Deselect',
  confirm: 'Confirm',
  confirm2: 'Confirm',
  delete: 'Delete',
  noDisabled: "Don't show",
  save: 'Save',
  clear: 'Clear',
  withdraw: 'Withdraw',
  confirmDelete: 'Confirm Delete',
  loading: 'Loading...',
  footerTab: {
    lighting: 'Lighting',
    itinerary: 'Itinerary',
    keys: 'Keys',
    keyboardSettings: 'Keyboard Settings',
    keyboardPerformanceSettings: 'Performance Settings',
    dpi: 'DPI Settings',
    performance: 'Performance',
    rt: 'Button Actuation',
    parameters: 'Parameters',
    mouseSettings: 'Mouse Settings',
    pages: 'Add Pages',
    playback: 'Playback Settings',
    baseSettings: 'Base Settings',
  },
  products: {
    A83_Air: {
      Glass_Blue: 'Glass Blue',
    },
    ESK900_75RT: {
      Blade_Pink: 'Blade Pink',
    },
    ESK900_83RT: {
      Black_Mist: 'Black Mist',
      Phantom_Green: 'Phantom Green',
      Translucent_Black: 'Translucent Black',
    },
    ESK900_98RT: {
      Abyss_Ranger: 'Abyss Ranger',
      Blaze_Wing_Star: 'Blaze Wing Star',
      Hacker_Agent: 'Hacker Agent',
      Infernal_Asura: 'Infernal Asura',
      Zero_Flame: 'Zero Flame',
    },
    ESM612PRO: {
      Raspberry_Pink: 'Raspberry Pink',
      Gray_Black_Red: 'Gray Black Red',
      Black_Gray_Orange: 'Black Gray Orange',
      White_Black_Yellow: 'White Black Yellow',
      Black_Purple_Green: 'Black PurPle Green',
      Vajra_Red: 'Vajra Red',
      Iridescent_Green: 'Iridescent Green',
      Emerald_Wind: 'Emerald Wind',
      Flame_Orange: 'Flame Orange',
      Black_Gray_Green: 'Black Gray Green',
    },
    ESM612MAX: {
      Raspberry_Pink: 'Raspberry Pink',
      Gray_Black_Red: 'Gray Black Red',
      Black_Gray_Orange: 'Black Gray Orange',
      White_Black_Yellow: 'White Black Yellow',
      Black_Purple_Green: 'Black PurPle Green',
      Vajra_Red: 'Vajra Red',
      Iridescent_Green: 'Iridescent Green',
      Black_Gray_Green: 'Black Gray Green',
    },
    ESM612ACE: {
      Raspberry_Pink: 'Raspberry Pink',
      Gray_Black_Red: 'Gray Black Red',
      Black_Gray_Orange: 'Black Gray Orange',
      White_Black_Yellow: 'White Black Yellow',
      Black_Purple_Green: 'Black PurPle Green',
      Vajra_Red: 'Vajra Red',
      Darkthorn: 'Darkthorn',
      Black_Gray_Green: 'Black Gray Green',
    },
    ESM622PRO: {
      Gray_Black_Red: 'Gray Black Red',
      Black_Gray_Orange: 'Black Gray Orange',
      White_Black_Yellow: 'White Black Yellow',
      Black_Purple_Green: 'Black PurPle Green',
      Black_Gray_Green: 'Black Gray Green',
    },
    ESM622MAX: {
      Gray_Black_Red: 'Gray Black Red',
      Black_Gray_Orange: 'Black Gray Orange',
      White_Black_Yellow: 'White Black Yellow',
      Black_Purple_Green: 'Black PurPle Green',
      Phantom_Green: 'Phantom Green',
      Black_Gray_Green: 'Black Gray Green',
    },
    ESM652PRO: {
      Raspberry_Pink: 'Raspberry Pink',
      Gray_Black_Red: 'Gray Black Red',
    },
    ESM672PRO: {
      Gray_Black_Red: 'Gray Black Red',
      Black_Gray_Orange: 'Black Gray Orange',
      White_Black_Yellow: 'White Black Yellow',
      Black_Purple_Green: 'Black PurPle Green',
      Black_Gray_Green: 'Black Gray Green',
    },
    ESM672MAX: {
      Gray_Black_Red: 'Gray Black Red',
      Black_Gray_Orange: 'Black Gray Orange',
      White_Black_Yellow: 'White Black Yellow',
      Black_Purple_Green: 'Black PurPle Green',
      Black_Gray_Green: 'Black Gray Green',
    },
    ESPR5: {
      Gray_Black_Red: 'Gray Black Red',
      Raspberry_Pink: 'Raspberry Pink',
    },
    ESPR7: {
      Emerald_Wind: 'Emerald Wind',
      Blazing_Sun_Orange: 'Blazing Sun Orange',
    },
    ESPR7PRO: {
      Gray_Black_Red: 'Gray Black Red',
      Raspberry_Pink: 'Raspberry Pink',
    },
    ESPR8: {
      Black_Purple_Green: 'Black PurPle Green',
      White_Black_Yellow: 'White Black Yellow',
      Raspberry_Pink: 'Raspberry Pink',
      Black_Gray_Green: 'Black Gray Green',
      Black_Gray_Orange: 'Black Gray Orange',
      Gray_Black_Red: 'Gray Black Red',
    },
    ESPR8PRO: {
      Iridescent_Green: 'Iridescent Green',
      Phantom_Green: 'Phantom Green',
    },
    P5_PLUS: {
      Black: 'Black',
      White: 'White',
      Raspberry_Pink: 'Raspberry Pink',
      Flame_Orange: 'Flame Orange',
    },
    P6_PLUS: {
      Black: 'Black',
      White: 'White',
    },
    V700diy_75: {
      White_Gray_Blue: 'White Gray Blue',
      Black_Gray_Green: 'Black Gray Green',
      Blue_Gray_Pink: 'Blue Gray Pink',
    },
    V700diy_87: {
      White_Gray_Blue: 'White Gray Blue',
      Black_Gray_Green: 'Black Gray Green',
      Blue_Gray_Pink: 'Blue Gray Pink',
    },
    V700diy_98: {
      White_Gray_Blue: 'White Gray Blue',
      Black_Gray_Green: 'Black Gray Green',
      Blue_Gray_Pink: 'Blue Gray Pink',
    },
    VT0: {
      Black: 'Black',
      Frozen_Blue: 'Frozen Blue',
      White: 'White',
    },
    VT0_MAX: {
      Black: 'Black',
      Frozen_Blue: 'Frozen Blue',
    },
    VT0Air_MAX: {
      Graffiti_Pink: 'Graffiti Pink',
      Graffiti_Purple: 'Graffiti Purple',
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT0_MAX_MASTER: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT1: {
      Black: 'Black',
      Flame_Orange: 'Flame Orange',
      White: 'White',
    },
    VT1_MAX: {
      Black: 'Black',
      Flame_Orange: 'Flame Orange',
      White: 'White',
    },
    VT1_SE: {
      Black: 'Black',
    },
    VT1S_V2: {
      Black: 'Black',
      Flame_Orange: 'Flame Orange',
      White: 'White',
    },
    VT1S_MAX_V2: {
      Black: 'Black',
      Flame_Orange: 'Flame Orange',
      White: 'White',
    },
    VT2: {
      Black: 'Black',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Lava_Red: 'Lava Red',
      Raspberry_Pink: 'Raspberry Pink',
      Skyline_Violet: 'Skyline Violet',
      White: 'White',
    },
    VT2_MAX: {
      Black: 'Black',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Lava_Red: 'Lava Red',
      Raspberry_Pink: 'Raspberry Pink',
      Skyline_Violet: 'Skyline Violet',
      White: 'White',
    },
    VT2_RT_V2: {
      Polar_Day: 'Polar Day',
    },
    VT2_RT_MASTER_V2: {
      First_Light: 'First Light',
    },
    VT2K_MAX: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT2_V2: {
      Black: 'Black',
      White: 'White',
      Lava_Red: 'Lava Red',
    },
    VT2S_V2: {
      Black: 'Black',
      Lava_Red: 'Lava Red',
      White: 'White',
    },
    VT2_MAX_V2: {
      Black: 'Black',
      White: 'White',
      Lava_Red: 'Lava Red',
      Raspberry_Pink: 'Raspberry Pink',
    },
    VT2S_MAX_V2: {
      Black: 'Black',
      White: 'White',
      Lava_Red: 'Lava Red',
    },
    VT2Air_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT2SAir_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT2_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT2S_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT2_ULTRA_V2: {
      Metallic_Crimson: 'Metallic Crimson',
    },
    VT3: {
      Black: 'Black',
      Flame_Orange: 'Flame Orange',
      Ice_Berry_Pink: 'Ice Berry Pink',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT3S: {
      Black: 'Black',
      Flame_Orange: 'Flame Orange',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT3_MAX: {
      Black: 'Black',
      Ice_Berry_Pink: 'Ice Berry Pink',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT3S_MAX: {
      Black: 'Black',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT3S_Air_Max: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT3S_MAX_MASTER: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT3_V2: {
      Black: 'Black',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT3S_V2: {
      Black: 'Black',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Raspberry_Pink: 'Raspberry Pink',
      Lava_Red: 'Lava_Red',
      White: 'White',
    },
    VT3_PRO_V2: {
      Fluorescent_Yellow: 'Fluorescent Yellow',
      White: 'White',
    },
    VT3S_PRO_V2: {
      Black: 'Black',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
      Lava_Red: 'Lava Red',
    },
    VT3_MAX_V2: {
      Black: 'Black',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT3S_MAX_V2: {
      Black: 'Black',
      Fluorescent_Yellow: 'Fluorescent Yellow',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT3Air_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT3SAir_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT3_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT3S_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT4_V2: {
      Black: 'Black',
      Mint_Green: 'Mint Green',
      White: 'White',
    },
    VT4_MAX_V2: {
      Black: 'Black',
      Mint_Green: 'Mint Green',
      White: 'White',
    },
    VT4Air_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT4_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT6: {
      Black: 'Black',
      Desert_Brown: 'Desert Brown',
      White: 'White',
    },
    VT6_MAX: {
      Black: 'Black',
      Desert_Brown: 'Desert Brown',
      White: 'White',
    },
    VT7: {
      Black: 'Black',
      Deep_Blue: 'Deep Blue',
      Flame_Orange: 'Flame Orange',
      Metallic_Blue: 'Metallic Blue',
      Metallic_Crimson: 'Metallic Crimson',
      Metallic_Purple: 'Metallic Purple',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT7_MAX: {
      Black: 'Black',
      Flame_Orange: 'Flame Orange',
      Metallic_Blue: 'Metallic Blue',
      Metallic_Crimson: 'Metallic Crimson',
      Metallic_Purple: 'Metallic Purple',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT7_V2: {
      Black: 'Black',
      Raspberry_Pink: 'Raspberry Pink',
      Snowpeak_Blue: 'Snowpeak Blue',
      White: 'White',
      Lava_Red: 'Lava Red',
    },
    VT7S_V2: {
      Black: 'Black',
      Raspberry_Pink: 'Raspberry Pink',
      Snowpeak_Blue: 'Snowpeak Blue',
      White: 'White',
      Lava_Red: 'Lava Red',
    },
    VT7_PRO_V2: {
      Black: 'Black',
      Snowpeak_Blue: 'Snowpeak Blue',
      White: 'White',
    },
    VT7_SE: {
      Black: 'Black',
    },
    VT7S_PRO_V2: {
      Black: 'Black',
      Raspberry_Pink: 'Raspberry Pink',
      Snowpeak_Blue: 'Snowpeak Blue',
      White: 'White',
    },
    VT7_MAX_V2: {
      Black: 'Black',
      White: 'White',
      Snowpeak_Blue: 'Snowpeak Blue',
      Raspberry_Pink: 'Raspberry Pink',
    },
    VT7S_MAX_V2: {
      Black: 'Black',
      Snowpeak_Blue: 'Snowpeak Blue',
      White: 'White',
    },
    VT7Air_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT7SAir_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT7_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT7S_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT8_V2: {
      Black: 'Black',
      White: 'White',
      Misty_Shadow_Gray: 'Misty Shadow Gray',
    },
    VT8_MAX_V2: {
      Black: 'Black',
      White: 'White',
      Misty_Shadow_Gray: 'Misty Shadow Gray',
    },
    VT8Air_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT8_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT9: {
      Black: 'Black',
      Electric_Purple: 'Electric Purple',
      Flame_Orange: 'Flame Orange',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT9_MAX: {
      Black: 'Black',
      Electric_Purple: 'Electric Purple',
      White: 'White',
    },
    VT9_V2: {
      Black: 'Black',
      Electric_Purple: 'Electric Purple',
      White: 'White',
    },
    VT9S_V2: {
      Black: 'Black',
      Electric_Purple: 'Electric Purple',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT9_PRO_V2: {
      Black: 'Black',
      Electric_Purple: 'Electric Purple',
      White: 'White',
    },
    VT9S_PRO_V2: {
      Black: 'Black',
      Electric_Purple: 'Electric Purple',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT9_MAX_V2: {
      Black: 'Black',
      Electric_Purple: 'Electric Purple',
      White: 'White',
    },
    VT9S_MAX_V2: {
      Black: 'Black',
      Electric_Purple: 'Electric Purple',
      Raspberry_Pink: 'Raspberry Pink',
      White: 'White',
    },
    VT9Air_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT9SAir_MAX_V2: {
      Morning_Mist_Blue: 'Morning Mist Blue',
    },
    VT9_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT9S_MAX_MASTER_V2: {
      Metallic_Iridescent: 'Metallic Iridescent',
    },
    VT68: {
      Yellow: 'Yellow',
      Black: 'Black',
    },
    VPR8_PLUS: {
      Black: 'Black',
    },
  },
}
